import React from 'react';
import { Skeleton } from 'antd';

export const ReviewSkeleton: React.FC = () => {
    return (
        <div className="review-skeleton">
            {/* Traveler Photos Skeleton */}
            <div className="photos-skeleton">
                <Skeleton.Button active block style={{ height: 400, borderRadius: 8 }} />
            </div>

            {/* Rating Summary Skeleton */}
            <div className="summary-skeleton">
                <div className="left-box">
                    <Skeleton active title paragraph={{ rows: 2 }} />
                </div>
                <div className="right-bars">
                    <Skeleton active title={false} paragraph={{ rows: 5 }} />
                </div>
            </div>

            {/* Search/Sort Skeleton */}
            <div className="search-sort-skeleton">
                <Skeleton.Input active style={{ width: '100%', height: 44, borderRadius: 30 }} />
                <Skeleton.Button active style={{ width: 160, height: 44, borderRadius: 30 }} />
            </div>

            {/* Review Items Skeleton */}
            {[1, 2, 3].map((i) => (
                <div key={i} className="review-item-skeleton">
                    <Skeleton active avatar title paragraph={{ rows: 3 }} />
                </div>
            ))}
        </div>
    );
};
